import React from 'react';
import { Content, PageWithHeader } from '@backstage/core-components';
import CustomApiExplorer from './CustomApiExplorer';

const CatalogApiDocs = () => {
  return (
    <PageWithHeader
      themeId="apis"
      title="APIs"
      subtitle="APIs page provides a preview for registered APIs with endpoints test
          capabilities if configured and documentations if available per API.
          The preview provides basic filtering and search, and links to GitHub
          repository. APIs creation and management is available in GitHub only
          with corresponding permissions."
    >
      <Content>
        <CustomApiExplorer />
      </Content>
    </PageWithHeader>
  );
};

export default CatalogApiDocs;
